import langGroup from "../../assets/lang.json";
import getLangKeyValueFun from "../../utils/lang";
const getText = getLangKeyValueFun(langGroup);
const IconFacebook = require("../../assets/images/facebook.svg");
const IconInstagram = require("../../assets/images/instagram.png");
const IconPinterest = require("../../assets/images/Pinterest.svg");
const IconYoutube = require("../../assets/images/youtube.svg");
const IconTwitter = require("../../assets/images/twitter.svg");
const IconTumblr = require("../../assets/images/tumblr.svg");
const Iconlitb_blog = require("../../assets/images/Bloggericon.svg");
const IconVk = require("../../assets/images/vk.svg");
const IconFacebookH = require("../../assets/images/facebook_hover.svg");
const IconInstagramH = require("../../assets/images/instagram_hover.png");
const IconPinterestH = require("../../assets/images/Pinterest_hover.svg");
const IconYoutubeH = require("../../assets/images/youtube_hover.svg");
const IconTwitterH = require("../../assets/images/twitter_hover.svg");
const IconTumblrH = require("../../assets/images/tumblr_hover.svg");
const Iconlitb_blogH = require("../../assets/images/Bloggericon_hover.svg");
const IconVkH = require("../../assets/images/vk_hover.svg");
const IconApple = require("../../assets/images/apple.svg");
const IconGoole = require("../../assets/images/google-play.svg");
const IconRich = require("../../assets/images/rich.svg");
const IconDirect = require("../../assets/images/manufacturer.svg");
const IconSafe = require("../../assets/images/safe.svg");
const IconFast = require("../../assets/images/fast.svg");
const IconFriendly = require("../../assets/images/friendly.svg");
export const BrightSpot = () => {
    return [
        {
            title: getText("Rich in Variety"),
            text: getText("1000+ New Items Everyday"),
            icon: IconRich,
        },
        {
            title: getText("Manufacturer Direct"),
            text: getText("Cut Out The Middleman"),
            icon: IconDirect,
        },
        {
            title: getText("Safe & Trustworthy"),
            text: getText("Secure payment"),
            icon: IconSafe,
        },
        {
            title: getText("Fast Delivery"),
            text: getText("Global Partner of DHL"),
            icon: IconFast,
        },
        {
            title: getText("Friendly Services"),
            text: getText("7-day Satisfaction Guarantee"),
            icon: IconFriendly,
        },
    ];
};
export const JoinOur = [
    {
        title: "facebook",
        icon: IconFacebook,
        iconH: IconFacebookH,
        link: "http://www.facebook.com/LightInTheBox?prm=1.1.78.0",
    },
    {
        title: "instagram",
        icon: IconInstagram,
        iconH: IconInstagramH,
        link: "https://www.instagram.com/LightInTheBox/?prm=1.1.78.0",
    },
    {
        title: "pinterest",
        icon: IconPinterest,
        iconH: IconPinterestH,
        link: "http://pinterest.com/LightInTheBox/",
    },
    {
        title: "youtube",
        icon: IconYoutube,
        iconH: IconYoutubeH,
        link: "http://www.youtube.com/lightinthebox?prm=1.1.78.0",
        style: {
            width: "24px",
            height: "20px"
        }
    },
    {
        title: "twitter",
        icon: IconTwitter,
        iconH: IconTwitterH,
        link: "http://twitter.com/lightinthebox?prm=1.1.78.0",
    },
    {
        title: "tumblr",
        icon: IconTumblr,
        iconH: IconTumblrH,
        link: "http://lightinthebox.tumblr.com/?prm=1.1.78.0",
    },
    {
        title: "litb_blog",
        icon: Iconlitb_blog,
        iconH: Iconlitb_blogH,
        link: "http://www.lightintheboxblog.com/?prm=1.1.78.0",
        style: {
            width: "18px",
            height: "18px"
        }
    },
    {
        title: "vk",
        icon: IconVk,
        iconH: IconVkH,
        link: "http://vk.com/lightinthebox?prm=1.1.78.0",
        style: {
            width: "22px",
            height: "20px"
        }
    },
];
export const OurMobileApps = [
    {
        title: getText("download app on the App Store"),
        name: "App Store",
        icon: IconApple,
        link: "https://itunes.apple.com/us/app/lightinthebox-online-shopping/id438474115",
    },
    {
        title: "download app on the Google Play",
        name: "Google Play",
        icon: IconGoole,
        link: "https://play.google.com/store/apps/details?id=com.lightinthebox.android",
    },
];
export const Info = () => {
    return [
        {
            title: getText("Company Info"),
            infos: [
                {
                    text: getText("About LightInTheBox.com"),
                    link: "/nh/About-Us.html?prm=1.1.84.0",
                },
                {
                    text: getText("LightInTheBox In The News"),
                    link: "/nh/Lightinthebox-News.html?prm=1.1.84.0",
                },
                {
                    text: getText("Investor Relations"),
                    link: "http://ir.lightinthebox.com?prm=1.1.84.0",
                    notOurs: true,
                },
            ]
        },
        {
            title: getText("Customer Service"),
            infos: [
                {
                    text: getText("Contact Us"),
                    link: "/r/contact-us.html?prm=1.1.85.0",
                },
                {
                    text: getText("Our Guarantee"),
                    link: "/nh/Our-Guarantee.html?prm=1.1.85.0",
                },
                {
                    text: getText("Track Your Order"),
                    link: "/index.php?main_page=login&amp;prm=1.1.85.0",
                },
                {
                    text: getText("Help Page and Knowledge Base"),
                    link: "/index.php?main_page=knowledgebase&amp;pg=kb.book&amp;type=base&amp;prm=1.1.85.0",
                },
                {
                    text: getText("CPSC Certification"),
                    link: "/t/CPSC_14?prm=1.1.85.0",
                },
            ]
        },
        {
            title: getText("Company Policies"),
            infos: [
                {
                    text: getText("Return Policy"),
                    link: "/nh/Return-Policy.html?prm=1.1.87.0"
                },
                {
                    text: getText("Privacy Notice"),
                    link: "/r/privacy.html?prm=1.1.87.0"
                },
                {
                    text: getText("Terms of Use"),
                    link: "/r/term-of-use.html?prm=1.1.87.0"
                },
                {
                    text: getText("Intellectual Property Infringement Policy"),
                    link: "/r/term-of-use.html?prm=1.1.87.0#_Intellectual_Property_Infringement_Policy"
                },
                {
                    text: getText("All you need to know"),
                    link: "/nh/All-You-Need-To-Know.html?prm=1.1.87.0"
                },
            ]
        },
        {
            title: getText("Payment & Methods"),
            infos: [
                {
                    text: getText("Payment Methods"),
                    link: "/knowledge-base/c1227/a2996.html?prm=1.1.86.0"
                },
                {
                    text: getText("Locations We Ship To"),
                    link: "/knowledge-base/c1229/a3020.html?prm=1.1.86.0"
                },
                {
                    text: getText("Estimated Delivery Time"),
                    link: "/knowledge-base/c1229/a3017.html?prm=1.1.86.0"
                },
            ]
        },
        {
            title: getText("Other Business"),
            infos: [
                {
                    text: getText("Affiliate Program"),
                    link: "/index.php?main_page=affiliate&amp;prm=1.1.88.0"
                },
                {
                    text: "成为兰亭供应商",
                    link: "/nh/Vendor-Company-Introduction.html?prm=1.1.88.0"
                },
            ]
        },
    ];
};
export const WebInfo = () => {
    return [
        {
            text: getText("Site Index"),
            link: "/Popular/?prm=1.1.81.0",
        },
        {
            text: getText("Site Map"),
            link: "/r/site-map.html?prm=1.1.84.0",
        },
        {
            text: getText("Check All Product Reviews"),
            link: "/reviews/?prm=1.1.83.0",
        },
    ];
};
export const SiteList = [
    {
        text: "A",
        link: "/Popular/Product_List_A/?prm=1.1.81.0",
    },
    {
        text: "B",
        link: "/Popular/Product_List_B/?prm=1.1.81.0",
    },
    {
        text: "C",
        link: "/Popular/Product_List_C/?prm=1.1.81.0",
    },
    {
        text: "D",
        link: "/Popular/Product_List_D/?prm=1.1.81.0",
    },
    {
        text: "E",
        link: "/Popular/Product_List_E/?prm=1.1.81.0",
    },
    {
        text: "F",
        link: "/Popular/Product_List_F/?prm=1.1.81.0",
    },
    {
        text: "G",
        link: "/Popular/Product_List_G/?prm=1.1.81.0",
    },
    {
        text: "H",
        link: "/Popular/Product_List_H/?prm=1.1.81.0",
    },
    {
        text: "I",
        link: "/Popular/Product_List_I/?prm=1.1.81.0",
    },
    {
        text: "J",
        link: "/Popular/Product_List_J/?prm=1.1.81.0",
    },
    {
        text: "K",
        link: "/Popular/Product_List_K/?prm=1.1.81.0",
    },
    {
        text: "L",
        link: "/Popular/Product_List_L/?prm=1.1.81.0",
    },
    {
        text: "M",
        link: "/Popular/Product_List_M/?prm=1.1.81.0",
    },
    {
        text: "N",
        link: "/Popular/Product_List_N/?prm=1.1.81.0",
    },
    {
        text: "O",
        link: "/Popular/Product_List_O/?prm=1.1.81.0",
    },
    {
        text: "P",
        link: "/Popular/Product_List_P/?prm=1.1.81.0",
    },
    {
        text: "Q",
        link: "/Popular/Product_List_Q/?prm=1.1.81.0",
    },
    {
        text: "R",
        link: "/Popular/Product_List_R/?prm=1.1.81.0",
    },
    {
        text: "S",
        link: "/Popular/Product_List_S/?prm=1.1.81.0",
    },
    {
        text: "T",
        link: "/Popular/Product_List_T/?prm=1.1.81.0",
    },
    {
        text: "U",
        link: "/Popular/Product_List_U/?prm=1.1.81.0",
    },
    {
        text: "V",
        link: "/Popular/Product_List_V/?prm=1.1.81.0",
    },
    {
        text: "W",
        link: "/Popular/Product_List_W/?prm=1.1.81.0",
    },
    {
        text: "X",
        link: "/Popular/Product_List_X/?prm=1.1.81.0",
    },
    {
        text: "Y",
        link: "/Popular/Product_List_Y/?prm=1.1.81.0",
    },
    {
        text: "Z",
        link: "/Popular/Product_List_Z/?prm=1.1.81.0",
    },
    {
        text: "0_9",
        link: "/Popular/Product_List_0_9/?prm=1.1.81.0",
    },
];
export const SiteInfo2 = () => {
    return [
        {
            title: getText("MiniInTheBox.com"),
            text: getText("Cool Gadgets with Free Shipping"),
            link: "https://www.miniinthebox.com",
        },
        {
            title: getText("SupplierPortal.litb.cn"),
            text: getText("Create a Better Future"),
            link: "https://supplierportal.litb.cn/",
        },
    ];
};
